import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { roleMS } from '../../../models/roleMS.model';
import { RoleUserMS } from '../../../models/roleUserMS.model';
import { ApplicationService } from '../../../services/application/applications.service';
import { RoleUserMSService } from '../../../services/utils/roleUserMS.service';

@Component({
  selector: 'app-rolesapplicationuser-form',
  providers: [],
  templateUrl: './rolesApplicationUsersForm.component.html'
})

// #FIXME: fixed dropdown PrimeNG bug on popu this way https://github.com/primefaces/primeng/issues/1494
// #FIXME: added to https://github.com/primefaces/primeng/issues/3964
export class RolesApplicationUserFormComponent implements OnInit {

  @Input() roleUser: RoleUserMS;
  @Input() role: roleMS;
  @Output() onSave: EventEmitter<any> = new EventEmitter<any>();
  usersAutoComplete: Array<{value: string, label: string}> = [{value: null, label: ''}]
  filteredUsersAutoComplete: any[];
  form: FormGroup;
  fields: any;
  public invalidSubmit: boolean;

  constructor (
    private srvRoleUserMS: RoleUserMSService,
    private srvApp: ApplicationService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {

    this.form = this.fb.group({
      'user_id': new FormControl('')
    });

    this.srvRoleUserMS.getFields().subscribe(res => {
      this.fields = res;
    });

    this.srvApp.getUserForApp(this.role.applicationId,99999).subscribe(res => {
      res.forEach( user => {
        this.usersAutoComplete.push({
          value: user.id,
          label: user.login + ' - ' +user.surname + ' ' + user.name
        });
      })
    });
  }

  save(): void {

    if (!this.form.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;

    let userString = this.form.value['user_id'];
    let userid = this.form.get('user_id').value;

    this.onSave.emit(userid);
  }

}




// WEBPACK FOOTER //
// ./src/app/views/administration/rolesApplication/rolesApplicationUsersForm.component.ts